import { render, staticRenderFns } from "./martyr.vue?vue&type=template&id=d4ee3d7c&"
import script from "./martyr.vue?vue&type=script&lang=js&"
export * from "./martyr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports